// CANONICAL COPY (GH #7115). src/constants/obligations/obl-change-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-change-management',
  title: 'Review change management procedures',
  description:
    'Verify that change management procedures are documented and followed for all changes to information processing facilities.',
  category: 'technical',
  scfIds: ['SCF-DEV-008'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Change management procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
